import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/veteran-facing-services-tools/veteran-facing-services-tools/packages/documentation/src/layouts/SidebarLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "how-are-urls-created"
    }}>{`How Are URLs Created?`}</h1>
    <div className="deprecation-message">
    <h2>We're moving our docs!</h2>
    <h3>Find <a href="https://depo-platform-documentation.scrollhelp.site/developer-docs/How-URLs-are-created.1855193145.html">the latest version of this page</a> on the Platform website.</h3>
    <h3>Still can't find what you're looking for? Reach out to <a href="https://dsva.slack.com/archives/CBU0KDSB1">#vfs-platform-support</a> on Slack.</h3>
    </div>
    <p>{`Understanding how content URLs are generated by Metalsmith helps prevent build errors. Here's how it works.`}</p>
    <h2 {...{
      "id": "pages-in-vagov-content"
    }}>{`Pages in vagov-content`}</h2>
    <ul>
      <li parentName="ul">{`Document paths are based on the Markdown file paths.`}</li>
      <li parentName="ul">{`Each Markdown file generates a corresponding directory and `}<inlineCode parentName="li">{`index.html`}</inlineCode>{` file. For example:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`_education/tools-programs.md`}</inlineCode>{` `}{`→`}{` `}<inlineCode parentName="li">{`/education/tools-programs/index.html`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`_education/tools-programs/index.md`}</inlineCode>{` `}{`→`}{` `}<inlineCode parentName="li">{`/education/tools-programs/index.html`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`_education/work-learn/non-traditional.md`}</inlineCode>{` `}{`→`}{` `}<inlineCode parentName="li">{`_education/work-learn/non-traditional/index.html`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <p><em parentName="p"><strong parentName="em">{`Make sure that every collection sub-directory also has a Markdown file that shares its name.`}</strong></em>{` Take the the `}<inlineCode parentName="p">{`_employment/job-seekers/`}</inlineCode>{` directory as an example. It also has an `}<inlineCode parentName="p">{`_employment/job-seekers.md`}</inlineCode>{` file. Each Markdown file in `}<inlineCode parentName="p">{`_employment/job-seekers/`}</inlineCode>{` compiles to  `}<inlineCode parentName="p">{`employment/jobs-seekers/name_of_markdown_file/index.html`}</inlineCode>{`, while `}<inlineCode parentName="p">{`_employment/job-seekers.md`}</inlineCode>{` itself compiles to `}<inlineCode parentName="p">{`employment/job-seekers/index.html`}</inlineCode>{`.`}</p>
    <p>{`Failing to take the above step means that you could generate breadcrumbs to pages that do not exist.`}</p>
    <h2 {...{
      "id": "pages-in-drupal"
    }}>{`Pages in Drupal`}</h2>
    <p>{`In Drupal, URLs are created based off the `}<inlineCode parentName="p">{`entityUrl.path`}</inlineCode>{` property included on each node. Similar to vagov-content pages, an index.html page is appended to that path, so that urls can reference just the path without an html extension.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      